"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZrxTradeQuote = void 0;
const api_1 = require("../../../api");
const getZrxMinMax_1 = require("../getZrxMinMax/getZrxMinMax");
const bignumber_1 = require("../utils/bignumber");
const constants_1 = require("../utils/constants");
const helpers_1 = require("../utils/helpers/helpers");
const zrxService_1 = require("../utils/zrxService");
async function getZrxTradeQuote(input) {
    var _a;
    try {
        const { sellAsset, buyAsset, sellAmount, sellAssetAccountId } = input;
        if (buyAsset.chainId !== 'eip155:1' || sellAsset.chainId !== 'eip155:1') {
            throw new api_1.SwapError('[getZrxTradeQuote] - Both assets need to be on the Ethereum chain to use Zrx', {
                code: api_1.SwapErrorTypes.UNSUPPORTED_PAIR,
                details: { buyAssetChainId: buyAsset.chainId, sellAssetChainId: sellAsset.chainId }
            });
        }
        const useSellAmount = !!sellAmount;
        const buyToken = buyAsset.tokenId || buyAsset.symbol;
        const sellToken = sellAsset.tokenId || sellAsset.symbol;
        const { minimum, maximum } = await (0, getZrxMinMax_1.getZrxMinMax)(sellAsset, buyAsset);
        const minQuoteSellAmount = (0, bignumber_1.bnOrZero)(minimum).times((0, bignumber_1.bn)(10).exponentiatedBy(sellAsset.precision));
        const normalizedSellAmount = (0, helpers_1.normalizeAmount)((0, bignumber_1.bnOrZero)(sellAmount).eq(0) ? minQuoteSellAmount.toString() : sellAmount);
        /**
         * /swap/v1/price
         * params: {
         *   sellToken: contract address (or symbol) of token to sell
         *   buyToken: contractAddress (or symbol) of token to buy
         *   sellAmount?: integer string value of the smallest increment of the sell token
         *   buyAmount?: integer string value of the smallest incremtent of the buy token
         * }
         */
        const quoteResponse = await zrxService_1.zrxService.get('/swap/v1/price', {
            params: {
                sellToken,
                buyToken,
                sellAmount: normalizedSellAmount
            }
        });
        const { data } = quoteResponse;
        const estimatedGas = (0, bignumber_1.bnOrZero)(data.estimatedGas).times(1.5);
        const rate = useSellAmount ? data.price : (0, bignumber_1.bn)(1).div(data.price).toString();
        return {
            success: true,
            statusReason: '',
            rate,
            minimum,
            maximum,
            feeData: {
                fee: (0, bignumber_1.bnOrZero)(estimatedGas).multipliedBy((0, bignumber_1.bnOrZero)(data.gasPrice)).toString(),
                chainSpecific: {
                    estimatedGas: estimatedGas.toString(),
                    gasPrice: data.gasPrice,
                    approvalFee: sellAsset.tokenId &&
                        (0, bignumber_1.bnOrZero)(constants_1.APPROVAL_GAS_LIMIT).multipliedBy((0, bignumber_1.bnOrZero)(data.gasPrice)).toString()
                }
            },
            sellAmount: data.sellAmount,
            buyAmount: data.buyAmount,
            sources: ((_a = data.sources) === null || _a === void 0 ? void 0 : _a.filter((s) => parseFloat(s.proportion) > 0)) || constants_1.DEFAULT_SOURCE,
            allowanceContract: data.allowanceTarget,
            buyAsset,
            sellAsset,
            sellAssetAccountId
        };
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[getZrxTradeQuote]', { cause: e, code: api_1.SwapErrorTypes.TRADE_QUOTE_FAILED });
    }
}
exports.getZrxTradeQuote = getZrxTradeQuote;
